import { EditProduct } from '../Common/Edit';

export const AddCodesPage = () => <EditProduct onlyAddCodes />;
